<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Настройки пользователя
    v-col(cols="12")
      profile-info

      //- email-confirm

      schedule(v-if="showSchedule")

      profile-form.mb-4(v-if="!isAdmin")

      password-form
      v-card(outlined v-if="isMain")
        v-card-title Настройки региона
        v-card-text
          WhenExpiry.ma-4
          timezone-settings.ma-4(v-if="isRegion || isAdmin")
</template>
<script>
import WhenExpiry from './components/RegionSettings/WhenExpiry.vue';
import { mapGetters } from 'vuex';
import { ROLES } from '@/constants';
import ProfileInfo from './components/ProfileInfo.vue';
import ProfileForm from './components/ProfileForm.vue';
import PasswordForm from './components/PasswordForm.vue';
import Schedule from './components/Schedule.vue';
import EmailConfirm from './components/EmailConfirm.vue';
import TimezoneSettings from './components/RegionSettings/TimezoneSettings/index.vue';
import checkRole  from '@/lib/checkRole';

export default {
  components: {
    WhenExpiry,
    ProfileForm,
    PasswordForm,
    Schedule,
    EmailConfirm,
    ProfileInfo,
    TimezoneSettings,
  },
  data() {
    return {
      ROLES,
    };
  },
  computed: {
    ...mapGetters({
      userRole: 'auth/userRole',
      user: 'auth/getUser',
      isAdmin:'auth/isAdmin',
      isRegion:'auth/isRegion',
      isSupport: 'auth/isSupport',
    }),
    showSchedule() {
      return checkRole(this.userRole, ROLES.region) && !this.user.parent_id;
    },
    isMain() {
      return this.user.parent_id == null && this.isRegion;
    },
  },

  methods: {

  },
};
</script>

<style></style>
